import Index from '@/pages/Index';
import Login from '@/pages/Login';
import LoginForCloudsignReview from '@/pages/LoginForCloudsignReview';
import LoginForLeFILING from '@/pages/LoginForLefiling';
import Router from 'vue-router';
import Vue from 'vue';
import path from './constants/path';
import store from './store/';

Vue.use(Router);

const router = new Router({
  scrollBehavior(to, from, savedPosition) {
    // 常にトップ位置にスクロール
    return { x: 0, y: 0 };
  },
  mode: 'history',
  routes: [
    {
      path: path.root,
      name: 'Index',
      component: Index
    },
    /**
     * ユーザー認証
     */
    {
      path: path.login,
      name: 'Login',
      component: Login
    },
    {
      path: path.loginForCloudsignReview,
      name: 'LoginForCloudsignReview',
      component: LoginForCloudsignReview
    },
    {
      path: path.loginForLeFILING,
      name: 'LoginForLeFILING',
      component: LoginForLeFILING
    },
    {
      path: path.passwordReset,
      name: 'PasswordReset',
      component: () => import('@/pages/PasswordReset')
    },

    {
      path: path.contractList,
      name: 'ContractList',
      component: () => import('@/pages/ContractList'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: path.splitUserTemplate,
      name: 'SplitUserTemplate',
      component: () => import('@/pages/SplitUserTemplate'),
      meta: {
        requiresAuth: true
      }
    },
    /**
     * キャビネット
     */
    {
      path: path.cabinetMaster,
      name: 'CabinetMaster',
      component: () => import('@/pages/cabinet_drive/CabinetMaster'),
      meta: {
        requiresAuth: true
      }
    },
    /**
     * 文書比較
     */
    {
      path: path.contractDiff,
      name: 'ContractDiff',
      component: () => import('@/pages/ContractDiff'),
      meta: {
        requiresAuth: true
      }
    },
    /**
     * タグルート（キャビネット）
     */
    {
      path: path.companyContractTagList,
      name: 'ContractTagList',
      component: () => import('@/pages/common/ContractTagList'),
      meta: {
        requiresAuth: true
      }
    },
    /**
     * 相手先ルート（キャビネット）
     */
    {
      path: path.clientList,
      name: 'ClientList',
      component: () => import('@/pages/common/client/ClientList'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: path.reviewContract,
      name: 'ReviewContract',
      component: () => import('@/pages/ReviewContract'),
      meta: {
        requiresAuth: true
      }
    },
    /**
     * LPルート
     */
    {
      path: path.terms,
      name: 'Terms',
      component: () => import('@/pages/lp/Terms'),
      meta: {
        // アクセス情報を取得するためにログイン必須にする
        requiresAuth: true
      }
    },
    {
      path: path.termsNoAuto,
      name: 'TermsNoAuto',
      component: () => import('@/pages/lp/TermsNoAuto')
    },
    {
      path: path.chatGptTerms,
      name: 'ChatGPTTerms',
      component: () => import('@/pages/lp/ChatGPTTerms')
    },
    {
      path: path.serviceLaw,
      name: 'ServiceLaw',
      component: () => import('@/pages/lp/ServiceLaw')
    },
    /**
     * Salesforce
     */
    {
      path: path.helpCenter,
      name: 'HelpCenter',
      component: () => import('@/pages/HelpCenter'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: path.prioritySettings,
      name: 'PrioritySettings',
      component: () => import('@/pages/PrioritySettings'),
      meta: {
        requiresAuth: true,
        requirePermission: true
      }
    },
    /**
     * 開発用Reactページへのルート
     */
    {
      path: path.editUserTemplate,
      name: 'EditUserTemplate',
      component: () => import('@/pages/EditUserTemplate'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: path.searchJoubun,
      name: 'SearchJoubun',
      component: () => import('@/pages/SearchJoubun'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: path.userSettings,
      name: 'UserSettings',
      component: () => import('@/pages/UserSettings'),
      meta: {
        requiresAuth: true
      }
    },
    /**
     * デフォルトルート 404
     */
    {
      path: path.pageNotFound,
      name: 'PageNotFound',
      component: () => import('@/pages/lp/PageNotFound')
    }
  ]
});

router.beforeEach((to, from, next) => {
  store.dispatch('loading/setIsLoadingCircular', false);
  const isCloudsignReview = localStorage.getItem('isCloudsignReview') === 'true';
  const loginPath = isCloudsignReview ? path.loginForCloudsignReview : path.login;

  // 権限がないのに直接アクセスしようとしたらログアウトさせる
  if (to.matched.some(record => record.meta.requirePermission)) {
    if (to.name === 'PrioritySettings') {
      if (!store.state.auth.company.companyContracts.companyPrioritySettings) {
        next({ path: loginPath });
        store.dispatch('auth/logout');
        return;
      }
    }
  }

  const refreshToken = localStorage.getItem('refresh');

  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (refreshToken != null) {
      // tokenが残っていれば検証
      store
        .dispatch('auth/tryLoggedIn')
        .then(() => {
          next();
        })
        .catch(() => {
          // 検証NGならログアウト処理をする
          store.dispatch('auth/logout');
        });
    } else {
      // tokenがない場合は、ログイン画面へ
      next({
        path: loginPath,
        query: {
          page: to.query.page,
          redirect: to.fullPath
        }
      });
      store.dispatch('auth/logout');
    }
  } else {
    // ログインが不要な画面であればそのまま次へ
    next();
  }
});

router.afterEach((to, from) => {
  // ページ遷移後はスクロールをトップへ
  window.scrollTo(0, 0);
});

export default router;



// WEBPACK FOOTER //
// ./src/router.js